import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import router from "@routes/router";
import { RouterProvider } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";

export const appTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#0a66c2", // Bleu LinkedIn officiel
      dark: "#004182",
      light: "#378fe9"
    },
    secondary: {
      main: "#56687a" // Gris secondaire professionnel
    },
    background: {
      default: "#f4f2ee", // Arrière-plan gris clair style LinkedIn
      paper: "#ffffff"   // Cartes blanches
    },
    text: {
      primary: "rgba(0, 0, 0, 0.9)",   // Texte principal foncé
      secondary: "rgba(0, 0, 0, 0.6)" // Texte secondaire atténué
    },
    divider: "rgba(0, 0, 0, 0.08)",     // Lignes de séparation très douces
    success: {
      main: "#057642" // Vert professionnel LinkedIn
    },
    error: {
      main: "#cc1011"
    }
  },

  shape: {
    borderRadius: 8 // Les cartes LinkedIn ont un rayon modéré
  },

  typography: {
    fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif`,
    h3: {
      fontWeight: 600,
      fontSize: "1.75rem",
      letterSpacing: "-0.01em"
    },
    h4: {
      fontWeight: 600,
      fontSize: "1.25rem"
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
      fontSize: "0.95rem"
    }
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#f4f2ee" // Fond uni épuré
        }
      }
    },

    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          borderRadius: 24, // Boutons arrondis "pill" style LinkedIn
          padding: "6px 16px",
          fontWeight: 600,
          boxShadow: "none"
        },
        containedPrimary: {
          backgroundColor: "#0a66c2",
          "&:hover": {
            backgroundColor: "#004182"
          }
        },
        outlinedPrimary: {
          borderColor: "#0a66c2",
          borderWidth: "1.5px",
          "&:hover": {
            borderWidth: "1.5px",
            backgroundColor: "rgba(10, 102, 194, 0.08)"
          }
        }
      }
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          boxShadow: "0 0 0 1px rgba(0,0,0,0.08)", // Fine bordure discrète au lieu d'une grosse ombre
          borderRadius: 8
        }
      }
    },

    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          border: "1px solid rgba(0, 0, 0, 0.08)",
          boxShadow: "none",
          transition: "box-shadow 0.2s ease, transform 0.2s ease",
          "&:hover": {
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)"
          }
        }
      }
    },

    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          fontWeight: 500,
          backgroundColor: "rgba(0, 0, 0, 0.08)"
        }
      }
    }
  }
});

function App() {
  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <LanguageProvider>
        <RouterProvider router={router} />
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
